import { Controller } from "@hotwired/stimulus"

// Spreadsheet-style filler rows: when actual results don't fill the
// scroll container, append empty <tr> rows so the table reads as
// continuous to the bottom of the viewport. Re-runs on resize.
export default class extends Controller {
    static values = {
        rowHeight:    { type: Number, default: 46 },
        headerHeight: { type: Number, default: 40 }
    }

    connect() {
        this.fill = this.fill.bind(this)
        this.observer = new ResizeObserver(this.fill)
        this.observer.observe(this.element)
        // Re-fill after a tick so layout has settled.
        requestAnimationFrame(this.fill)
    }

    disconnect() {
        this.observer?.disconnect()
    }

    fill() {
        const wrap = this.element
        const tbody = wrap.querySelector('tbody')
        if (!tbody) return

        // Remove previous fillers before recomputing.
        tbody.querySelectorAll('tr[data-filler="true"]').forEach(el => el.remove())

        const headEl     = wrap.querySelector('thead')
        const headerH    = headEl?.offsetHeight || this.headerHeightValue
        const realRowsH  = tbody.offsetHeight
        const containerH = wrap.clientHeight
        const remaining  = containerH - headerH - realRowsH
        if (remaining <= 0) return

        const fillerCount = Math.ceil(remaining / this.rowHeightValue)
        if (fillerCount <= 0) return

        const headerCells = Array.from(wrap.querySelectorAll('thead th'))
        if (headerCells.length === 0) return

        const fragment = document.createDocumentFragment()
        for (let i = 0; i < fillerCount; i++) {
            const tr = document.createElement('tr')
            tr.dataset.filler = "true"
            tr.className = "lf-empty-row"
            headerCells.forEach(th => {
                const td = document.createElement('td')
                // Copy column classes (lf-sticky-check, lf-col-*) so widths
                // and sticky behavior carry over and column borders align.
                td.className = th.className
                tr.appendChild(td)
            })
            fragment.appendChild(tr)
        }
        tbody.appendChild(fragment)
    }
}
